<div class="collapsible" [ngClass]="{'collapsible--expended': expanded }">
  <div class="collapsible__header" (click)="toggle()">
    <span class="text-medium semi-bold" *ngIf="title">
      {{title}}
    </span>

    <img src="/assets/icons/arrow-simple.svg" class="collapsible__icon">
  </div>
  <div class="collapsible__content"
     [@collapse]="
        {
          value: (expanded ? 'expanded' : 'collapsed')
        }
      "
  >
    <ng-content select="[hiddenContent]"></ng-content>
  </div>
</div>
